import {Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild} from '@angular/core';
import {NgbNav, NgbNavChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import {NavTabComponent} from "../nav-tab/nav-tab.component";

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss']
})
export class NavTabsComponent {
  @ContentChildren(NavTabComponent) tabs: QueryList<NavTabComponent> | undefined;
  @Input() reduceHorizontalSpacing: boolean | false = false;
  @Input() active: number | undefined;
  @Output() onChange: EventEmitter<number | undefined> = new EventEmitter<number | undefined>();
  @Input() tabCssClass: string | undefined
  @ViewChild("nav") nav?: NgbNav;

  select(id: number) {
    this.nav?.select(id);
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    this.onChange.emit(changeEvent.nextId)
  }
}
